import {createGlobalStyle} from 'styled-components';
import {normalize} from 'styled-normalize';

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
const BasicStyles = createGlobalStyle`
  /* Unlayered CSS beats every Tailwind layer, so normalize goes below the platform utilities. */
  @layer base {
    ${normalize}
  }

  html {
    height: 100%;
  }

  body {
    color: ${({theme}) => theme.colors.palettes.neutral[900][100]};
    font-family: ${({theme}) => theme.fonts.body};
    font-size: ${({theme}) => theme.fontSizes.text.small};
    font-weight: normal;
    //line-height: ${({theme}) => theme.lineHeights.text.base};
    background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
    font-style: normal;
    height: 100%;
    overflow: hidden;
    overscroll-behavior-y: none;

    @media print {
      background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
    }
  }

  #root {
    height: 100%;
    position: relative;
    overflow: hidden;
  }
`;

export function GlobalStyles() {
  return <BasicStyles />;
}
